import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  List,
  ListItem,
  ListItemText,
  Container,
  Typography,
  Box,
  Grid
} from '@material-ui/core';
import moment from 'moment';
import { useClaimsContext } from '../../context/claims_context';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  demo: {
    backgroundColor: theme.palette.background.paper
  },
  title: {
    margin: theme.spacing(4, 0, 2)
  },
  typo: {
    fontWeight: 'bold',
    paddingRight: 20,
    textAlign: 'right'
  }
}));

export default function BatchDetails() {
  const classes = useStyles();
  const { currentBatch, setCurrentBatch } = useClaimsContext();

  useEffect(() => {
    // if (currDependant.cif_number > 0) {
    //   getLimitUsage(currDependant);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBatch]);

  return (
    <Container>
      <Card>
        <div className={classes.root}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <div className={classes.demo}>
                <List dense>
                  {/* <ListItem>
                    <ListItemText>Batch Id</ListItemText>
                    <ListItemText>
                      <Box className={classes.typo} style={{ paddingRight: 20 }}>
                        {currentBatch.batchID}
                      </Box>
                    </ListItemText>
                  </ListItem> */}
                  <ListItem>
                    <ListItemText>Batch #</ListItemText>
                    <ListItemText>
                      <Box className={classes.typo} style={{ paddingRight: 20 }}>
                        {currentBatch.batch_No}
                      </Box>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>Batch Date</ListItemText>
                    <ListItemText>
                      <Typography className={classes.typo}>
                        {moment(currentBatch.batchReceivedOn).isValid()
                          ? moment(currentBatch.batchReceivedOn).format('YYYY-MM-DD')
                          : ''}
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>Batch Status</ListItemText>
                    <ListItemText>
                      <Box className={classes.typo} style={{ paddingRight: 20 }}>
                        {currentBatch.status_Descr}
                      </Box>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText># of Claims</ListItemText>
                    <ListItemText>
                      <Box className={classes.typo} style={{ paddingRight: 20 }}>
                        {currentBatch.no_of_Docs}
                      </Box>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>Running Count</ListItemText>
                    <ListItemText>
                      <Box className={classes.typo} style={{ paddingRight: 20 }}>
                        {currentBatch.runningCount}
                      </Box>
                    </ListItemText>
                  </ListItem>
                </List>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className={classes.demo}>
                <List dense>
                  <ListItem>
                    <ListItemText>Provider</ListItemText>
                    <ListItemText>
                      {/* <Typography className={classes.typo}>{currentLoan.productName}</Typography> */}
                      <Box className={classes.typo} style={{ paddingRight: 20 }}>
                        {currentBatch.provider}
                      </Box>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>AHFOZ #</ListItemText>
                    <ListItemText>
                      <Box className={classes.typo} style={{ paddingRight: 20 }}>
                        {currentBatch.namasNo}
                      </Box>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>Pay Cycle</ListItemText>
                    <ListItemText>
                      <Typography className={classes.typo}>
                        {moment(currentBatch.payDate).isValid()
                          ? moment(currentBatch.payDate).format('YYYY-MM-DD')
                          : ''}
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>Batch Total</ListItemText>
                    <ListItemText>
                      <Box className={classes.typo} style={{ paddingRight: 20 }}>
                        {currentBatch.batchTotal.toFixed(2)}
                      </Box>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>Running Total</ListItemText>
                    <ListItemText>
                      <Box className={classes.typo} style={{ paddingRight: 20 }}>
                        {currentBatch.runningTotal}
                      </Box>
                    </ListItemText>
                  </ListItem>
                </List>
              </div>
            </Grid>
          </Grid>
        </div>
      </Card>
    </Container>
  );
}
